/**
 * Shared UI component for UI Profile Avatar.
 * PARENT-CHILD CONTRACT: parent screens provide the data and configuration that
 * this wrapper renders or normalizes for reuse across the application.
 */
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { UiLabelTranslatePipe } from '../ui-label-translate.pipe';

@Component({
  selector: 'ui-profile-avatar',
  standalone: true,
  imports: [UiLabelTranslatePipe],
  templateUrl: './ui-profile-avatar.component.html',
  styleUrl: './ui-profile-avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiProfileAvatarComponent {
  readonly imageSrc = input('');
  readonly initials = input('');
  readonly alt = input('Profile image');
  readonly label = input('');
  readonly hint = input('');
  readonly canDelete = input(false);
  readonly editLabel = input('Edit image');
  readonly deleteLabel = input('Remove image');
  readonly fileSelected = output<File>();
  readonly removeClicked = output<void>();

  readonly displayInitials = computed(() => this.initials().trim().slice(0, 2).toUpperCase());

  onFileSelected(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const file = inputElement.files?.[0];

    if (!file) {
      return;
    }

    this.fileSelected.emit(file);
    inputElement.value = '';
  }

  onRemoveClicked(): void {
    this.removeClicked.emit();
  }
}
